// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 250px;
    height: 100vh;
    background: #050A30;
    position: fixed;
    top: 0;
    left: 0;
    padding: 20px;
    box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    margin-top: 70px;
    z-index: 1050;
}

.hide {
    transform: translateX(-100%);
}

.show {
    transform: translateX(0);
}

.btn-close-sidebar {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    align-self: flex-end;
    margin-bottom: 20px;
    transition: color 0.3s ease;
}

.btn-close-sidebar:hover {
    color: red;
}

.menu-section {
    margin-bottom: 20px;
}

.menu-item {
    display: block;
    background: #1b1f3b;
    color: white;
    font-size: 16px;
    padding: 12px 20px;
    border-radius: 10px;
    margin-bottom: 10px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
}

.menu-item:hover {
    background: #2c3159;
    transform: scale(1.05);
}

@media (max-width: 768px) {
    .sidebar {
        width: 100%;
        height: 100vh;
        position: fixed;
        background: rgba(5, 10, 48, 0.95);
        padding: 30px;
        margin-top: 60px;
    }

    .menu-item {
        font-size: 18px;
        padding: 14px;
    }

    .btn-close-sidebar {
        font-size: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,2CAA2C;IAC3C,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,iCAAiC;QACjC,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".sidebar {\n    width: 250px;\n    height: 100vh;\n    background: #050A30;\n    position: fixed;\n    top: 0;\n    left: 0;\n    padding: 20px;\n    box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.2);\n    transition: transform 0.3s ease-in-out;\n    display: flex;\n    flex-direction: column;\n    margin-top: 70px;\n    z-index: 1050;\n}\n\n.hide {\n    transform: translateX(-100%);\n}\n\n.show {\n    transform: translateX(0);\n}\n\n.btn-close-sidebar {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 24px;\n    cursor: pointer;\n    align-self: flex-end;\n    margin-bottom: 20px;\n    transition: color 0.3s ease;\n}\n\n.btn-close-sidebar:hover {\n    color: red;\n}\n\n.menu-section {\n    margin-bottom: 20px;\n}\n\n.menu-item {\n    display: block;\n    background: #1b1f3b;\n    color: white;\n    font-size: 16px;\n    padding: 12px 20px;\n    border-radius: 10px;\n    margin-bottom: 10px;\n    text-decoration: none;\n    transition: all 0.3s ease-in-out;\n}\n\n.menu-item:hover {\n    background: #2c3159;\n    transform: scale(1.05);\n}\n\n@media (max-width: 768px) {\n    .sidebar {\n        width: 100%;\n        height: 100vh;\n        position: fixed;\n        background: rgba(5, 10, 48, 0.95);\n        padding: 30px;\n        margin-top: 60px;\n    }\n\n    .menu-item {\n        font-size: 18px;\n        padding: 14px;\n    }\n\n    .btn-close-sidebar {\n        font-size: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
